export const GET_ORGANIZATIONS = "GET_ORGANIZATIONS";
export const RESET_ORGANIZATIONS = "RESET_ORGANIZATIONS";
export const SET_ORGANIZATIONS_REQUEST_STATUS = "SET_ORGANIZATIONS_REQUEST_STATUS";
